var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "emd-text-section",
    { attrs: { title: _vm.$t("payment-method.boleto") } },
    [
      Object.values(_vm.data.dueIn).length
        ? _c("emd-text-content", { attrs: { title: _vm.$t("dueIn.title") } }, [
            _c("div", { staticClass: "eu-inline" }, [
              _vm.data.dueIn.years
                ? _c("span", [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$tc("dueIn.years", _vm.data.dueIn.years)) +
                        " "
                    ),
                  ])
                : _vm._e(),
              _vm.data.dueIn.months
                ? _c("span", [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$tc("dueIn.months", _vm.data.dueIn.months)) +
                        " "
                    ),
                  ])
                : _vm._e(),
              _vm.data.dueIn.months && _vm.data.dueIn.days
                ? _c("span", [
                    _vm._v(" " + _vm._s(_vm.$t("dueIn.append")) + " "),
                  ])
                : _vm._e(),
              _vm.data.dueIn.days
                ? _c("span", [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$tc("dueIn.days", _vm.data.dueIn.days)) +
                        " "
                    ),
                  ])
                : _vm._e(),
            ]),
          ])
        : _c("due-at", { attrs: { dueAt: _vm.data.dueAt } }),
      _c("discount", { attrs: { data: _vm.data } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }